import { render, staticRenderFns } from "./groupTabs.vue?vue&type=template&id=50fca619&"
import script from "./groupTabs.vue?vue&type=script&lang=js&"
export * from "./groupTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports